export default __webpack_public_path__ + "static/media/step1.466648d8.png";